import { Constantes } from 'src/app/core/global/constantes';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appSoloEnterosPositivos]'
})
export class SoloEnterosPositivosDirective {

    // Permite códigos clave para eventos especiales.
    // Backspace, tab, end, home
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

    constructor(private el: ElementRef) {
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Permite Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        let current: string = this.el.nativeElement.value;

        const position = this.el.nativeElement.selectionStart;
        const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');

        if (next && !String(next).match(Constantes.REGEX_NUMERO_ENTERO_POSITIVO)) {
            event.preventDefault();
        }
    }

}